module.exports = __webpack_public_path__ + "img/normal-big.e2ec2450.svg";